import { MagnifyingGlassIcon } from '@gto/icons-react/outline/magnifying-glass'
import { cn } from '@gto/ui/cn'
import type { InputProps } from '@gto/ui/input'
import { Input } from '@gto/ui/input'

type SearchInputProps = Omit<InputProps, 'startAddon' | 'endAddon'>

/** Placeholder-only search box (no label/Field wrapper — tests query by placeholder).
 *  Bounded width by default: the DS Input is w-full, which would swallow a flex
 *  toolbar row; override via className where a different width is needed. */
export const SearchInput = ({ className, size = 'small', ...props }: SearchInputProps) => (
  <Input
    className={cn('w-[220px]', className)}
    size={size}
    startAddon={
      <MagnifyingGlassIcon
        height={16}
        width={16}
      />
    }
    {...props}
  />
)
